import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DashboardFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DashboardFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M8 2v6H2V7c0-2.76 2.24-5 5-5h1ZM2 17v-7h12v12H7c-2.76 0-5-2.24-5-5ZM10 8h12V7c0-2.76-2.24-5-5-5h-7v6ZM16 10v12h1c2.76 0 5-2.24 5-5v-7h-6Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default DashboardFilled;